/* This is the EMIS toilet components */

<template>
  <v-container>
		<div>
			<span v-html="title"></span>
		</div>
		<div>
			<table style="height: 75px;" width="810" border="1px;" cellspacing="0px;">
				<tbody>
					<tr>
						<td style="width: 250px; height: 25px; text-align: center; vertical-align: middle;">ប្រភេទ</td>
						<td class="row-data">
							<p>បង្គន់</p>
							គ្រូប្រុស</td>
						<td class="row-data">
							<p>បង្គន់</p>
							គ្រូស្រី</td>
						<td class="row-data">
							<p>បង្គន់</p>
							គ្រូរួម</td>
						<td class="row-data">
							<p>បង្គន់</p>
							សិស្សប្រុស</td>
						<td class="row-data">
							<p>បង្គន់</p>
							សិស្សស្រី
						</td>
						<td class="row-data">
							<p>បង្គន់</p>
							សិស្សរួម
						</td>
						<td class="row-data">
							<p>បង្គន់</p>
							រួម</td>
						<td class="row-data">
							<p>បង្គន់</p>
							សិស្សពិការ</td>
					</tr>
					<tr v-for="(value, row) in toiletRow.length" :key="row">
						<td style="width: 56px; height: 25px; text-align: left; vertical-align: middle;">
							{{ toiletRow[row] }}
						</td>
						<td v-for="(value, col) in data[row].dt.length" :key="col" 
							:class="[ !toiletOnOff[row][col] ? 'row-data-gray' : 'row-data' ]">
							<numberinput v-model="data[row].dt[col]" :disabled="!toiletOnOff[row][col]"
								class="number"/>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
  </v-container>
</template>

<script>
import { toiletRow, toiletOnOff } from '@/utils/ascf/commonConfig.js'
import NumberInput from '@/components/common/NumberInput.vue'
export default {
	props: ["data", "title"],
	components: {
		'numberinput': NumberInput
  },
  data() {
    return {
			toiletRow: toiletRow,
			toiletOnOff: toiletOnOff
    }
	}
}
</script>
<style scoped>
.number {
	width:70px;
	text-align: center;
}
.row-data {
	width: 70px;
	height: 25px;
	text-align: center;
	vertical-align: middle;
}
.row-data-gray {
	width: 70px;
	height: 25px;
	text-align: center;
	vertical-align: middle;
	background-color: lightgray;
}
.row-data-left {
	width: 70px;
	height: 25px;
	text-align: center;
	vertical-align: middle;
}
</style>